import { render, staticRenderFns } from "./ReadChat.vue?vue&type=template&id=7cd1112c&scoped=true&"
import script from "./ReadChat.vue?vue&type=script&lang=js&"
export * from "./ReadChat.vue?vue&type=script&lang=js&"
import style0 from "./ReadChat.vue?vue&type=style&index=0&id=7cd1112c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd1112c",
  null
  
)

export default component.exports